module.exports = __webpack_public_path__ + "img/4.1ba05936.jpg";